import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=565f6843&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f6843",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565f6843')) {
      api.createRecord('565f6843', component.options)
    } else {
      api.reload('565f6843', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=565f6843&scoped=true&", function () {
      api.rerender('565f6843', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/common/AppFooter.vue"
export default component.exports